export default {"src":"https://fishbrain.com/_next/static/media/wisconsin.95582b8f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};